
// THIS FILE IS AUTOGENERATED AS PART OF THE EXTENSION AND MODE PLUGIN PROCESS.
// IT SHOULD NOT BE MODIFIED MANUALLY 
import extensions0 from '@ohif/extension-cornerstone';
import extensions1 from '@ohif/extension-measurement-tracking';
import extensions2 from '@ohif/extension-dicom-sr';
import extensions3 from '@ohif/extension-default';
import extensions4 from '@ohif/extension-dicom-pdf';
import extensions5 from '@ohif/extension-dicom-video';
import modes0 from '@ohif/mode-longitudinal';
window.extensions = [];
window.modes = [];

window.extensions.push(extensions0);
window.extensions.push(extensions1);
window.extensions.push(extensions2);
window.extensions.push(extensions3);
window.extensions.push(extensions4);
window.extensions.push(extensions5);
window.modes.push(modes0);
